import './style.scss';

import { PageBlock } from '@design-system/page-block';
import React, { FC } from 'react';

import { IframeProps } from './models';

const Iframe: FC<IframeProps> = ({
  pageBlockUI,
  componentId,
  title,
  name,
  height,
  width,
  src,
  sandbox: { allowances },
  allow: { flags },
  referrerpolicy,
  uid,
}) => (
  <PageBlock
    {...pageBlockUI}
    id={componentId}
    className="iframe-container"
    componentUid={uid}
  >
    <iframe
      data-testid="iframe"
      title={title}
      name={name}
      height={height}
      width={width}
      src={src}
      sandbox={allowances.join(' ')}
      allow={flags.length ? flags.join('; ') : undefined}
      referrerPolicy={referrerpolicy}
    />
  </PageBlock>
);

export default Iframe;
